<!-- <mat-card class="subscription-card">
  <mat-card-title>Subscribe Now</mat-card-title>
  <form [formGroup]="subscriptionForm" (ngSubmit)="submit()">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="John Doe" />
      <mat-error *ngIf="subscriptionForm.get('name')?.hasError('required')">
        Name is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" placeholder="email@example.com" />
      <mat-error *ngIf="subscriptionForm.get('email')?.hasError('required')">
        Email is required
      </mat-error>
      <mat-error *ngIf="subscriptionForm.get('email')?.hasError('email')">
        Enter a valid email
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Plan</mat-label>
      <mat-select formControlName="plan">
        <mat-option *ngFor="let plan of plans" [value]="plan">{{ plan }}</mat-option>
      </mat-select>
      <mat-error *ngIf="subscriptionForm.get('plan')?.hasError('required')">
        Please select a plan
      </mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="agreeTerms">
      I agree to the terms and conditions
    </mat-checkbox>
    <mat-error *ngIf="subscriptionForm.get('agreeTerms')?.hasError('required')">
      You must agree before submitting
    </mat-error>

    <div class="actions">
      <button mat-raised-button color="primary" type="submit">Subscribe</button>
    </div>
  </form>
</mat-card> -->

<!-- <div class="bg-white rounded-lg py-3 mb-6 px-3 pricing-container">
  <h2>Pricing</h2>

  <mat-button-toggle-group [value]="billingCycle" (change)="setBillingCycle($event?.value)" appearance="legacy"
    class="billing-toggle">
    <mat-button-toggle value="Annual">Annual</mat-button-toggle>
    <mat-button-toggle value="Monthly">Monthly</mat-button-toggle>
  </mat-button-toggle-group>

  <div class="plans" *ngFor="let package of packageList">
        <mat-card class="plan-card" [ngClass]="{ active: isSelected('Recruit Basic') }"
      (click)="selectPlan('Recruit Basic')">
      <div class="tag">Active</div>
      <h3>{{package?.package_name}}</h3>
      <p class="price">₹{{package?.amount}} <span>/ month (INR)</span></p>
      <p class="billed">₹{{package?.amount}} billed yearly</p>
      <p class="desc">Ideal for small teams with fundamental needs</p>

      <ul>
        <li><mat-icon>check_circle</mat-icon> Access to core HR features</li>
        <li><mat-icon>check_circle</mat-icon> Employee record management</li>
        <li><mat-icon>check_circle</mat-icon> Basic reporting tools</li>
        <li><mat-icon>check_circle</mat-icon> Manage up to {{package?.user_count}} team members</li>
        <li><mat-icon>check_circle</mat-icon> Manage up to {{package?.project_count}} team members</li>
        <li><mat-icon color="warn">cancel</mat-icon> Track employee attendance</li>
        <li><mat-icon color="warn">cancel</mat-icon> Assign and monitor tasks</li>
        <li><mat-icon color="warn">cancel</mat-icon> Email support</li>
      </ul>
      <button mat-stroked-button color="warn"(click)=subscribePackage(package?.id)>Subscribe</button>
    </mat-card>

    
  </div>
</div> -->

<!-- Modern Subscription Dashboard -->
<div class="subscription-dashboard">
  <!-- Loading State -->
  <div class="loading-state" *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading subscription details...</p>
  </div>

  
  <!-- No Subscription State -->
  <div class="error-state" *ngIf="error && !loading">
    <mat-icon class="error-icon">error</mat-icon>
    <h3>No Subscriptions</h3>
    <!-- <p>{{ error }}</p> -->
    <button mat-raised-button color="primary" routerLink="/plan">
      <mat-icon>refresh</mat-icon>
      Purchase Subscription
    </button>
  </div>

  <!-- Error State -->
  <!-- <div class="error-state" *ngIf="error && !loading">
    <mat-icon class="error-icon">error</mat-icon>
    <h3>Error Loading Subscriptions</h3>
    <p>{{ error }}</p>
    <button mat-raised-button color="primary" (click)="getSubscriptionDetails()">
      <mat-icon>refresh</mat-icon>
      Try Again
    </button>
  </div> -->

  <!-- Main Content -->
  <div *ngIf="!loading && !error">
    <!-- Header Section -->
    <div class="dashboard-header">
      <div class="header-content">
        <h1 class="dashboard-title">
          <mat-icon class="title-icon">subscriptions</mat-icon>
          {{'SUBSCRIPTION_DASHBOARD' | translate}}
        </h1>
          {{'SUBSCRIPTION_DESC' | translate}}
        <p class="dashboard-subtitle"></p>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          color="primary"
          class="header-action-btn"
          (click)="showUpgradeOptions()"
          [disabled]="subscriptions.length === 0 || isSuperAdmin"
        >
          <mat-icon>upgrade</mat-icon>
          {{'UPGRADE_PLAN' | translate}}
        </button>
        <button
          mat-raised-button
          color="primary"
          class="header-action-btn"
          (click)="showRenewOptions()"
          [disabled]="!canRenew() || isSuperAdmin"
        >
          <mat-icon>autorenew</mat-icon>
          Renew
        </button>
      </div>
    </div>

  <!-- Super Admin: all organizations subscription list -->
  <div class="superadmin-subscription-wrap" *ngIf="isSuperAdmin && subscriptions.length > 0">
    <h2 class="superadmin-list-title">
      <mat-icon>business</mat-icon>
      {{ 'SUBSCRIPTION_LIST_BY_ORGANIZATION' | translate }}
    </h2>
    <div class="superadmin-table-wrap">
      <table class="superadmin-subscription-table">
        <thead>
          <tr>
            <th>{{ 'ORGANIZATION_NAME' | translate }}</th>
            <th>{{ 'ORGANIZATION_ID' | translate }}</th>
            <th>{{ 'SUBSCRIPTION' | translate }}</th>
            <th>{{ 'STATUS' | translate }}</th>
            <th>{{ 'TOTAL_AMOUNT' | translate }}</th>
            <th>{{ 'START_DATE_' | translate }}</th>
            <th>{{ 'END_DATE_' | translate }}</th>
            <th>{{ 'ACCESS' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sub of subscriptions">
            <td class="cell-org-name">{{ sub.org_name || '—' }}</td>
            <td>{{ sub.organization_id }}</td>
            <td>#{{ sub.id }}</td>
            <td>
              <span class="table-status" [ngClass]="getStatusClass(sub)">{{ getStatusText(sub) }}</span>
            </td>
            <td>₹{{ sub.total_amount | number }}</td>
            <td>{{ sub.membership_start_date | date:'mediumDate' }}</td>
            <td>{{ sub.membership_end_date | date:'mediumDate' }}</td>
            <td>
              <span [ngClass]="getStatusDetails(sub).canAccess ? 'access-granted' : 'access-denied'">
                {{ getStatusDetails(sub).canAccess ? ('GRANTED' | translate) : ('DENIED' | translate) }}
              </span>
            </td>
            <td class="cell-actions">
              <button mat-icon-button (click)="viewDetails(sub)" matTooltip="{{ 'VIEW_DETAILS' | translate }}">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Subscription Overview Cards -->
  <div class="overview-cards" *ngIf="subscriptions.length > 0 && !isSuperAdmin">
    <div class="overview-card primary">
      <div class="card-icon">
        <mat-icon>calendar_today</mat-icon>
      </div>
      <div class="card-content">
        <h3>{{'ACTIVE_SUBSCRIPTIONS' | translate}}</h3>
        <p class="card-value">{{ getActiveSubscriptionsCount() }}</p>
        <p class="card-label">Current Plans</p>
      </div>
    </div>

    <div class="overview-card success">
      <div class="card-icon">
        <mat-icon>schedule</mat-icon>
      </div>
      <div class="card-content">
        <h3>{{'DAYS_REMAINING' | translate}}</h3>
        <p class="card-value">{{ getPrimaryDaysRemaining() }}</p>
        <p class="card-label">Until Renewal</p>
      </div>
    </div>

    <div class="overview-card warning">
      <div class="card-icon">
        <mat-icon>group</mat-icon>
      </div>
      <div class="card-content">
        <h3>{{'TOTAL_USERS' | translate}}</h3>
        <p class="card-value">{{ getTotalUsers() }}</p>
        <p class="card-label">Across All Plans</p>
      </div>
    </div>

    <div class="overview-card info">
      <div class="card-icon">
        <mat-icon>payments</mat-icon>
      </div>
      <div class="card-content">
        <h3>{{'TOTAL_INVESTMENT' | translate}}</h3>
        <p class="card-value">₹{{ getTotalAmount() | number }}</p>
        <p class="card-label">Lifetime Value</p>
      </div>
    </div>
  </div>

  <!-- Main Subscription Cards (organization and other users — unchanged) -->
  <div class="subscription-grid" *ngIf="!isSuperAdmin">
    <div *ngFor="let sub of subscriptions; let i = index" 
         class="subscription-card"
         [ngClass]="getStatusClass(sub)">
      
      <!-- Card Header -->
      <div class="card-header">
        <div class="header-left">
          <div class="subscription-badge">
            <mat-icon>verified</mat-icon>
            <span>{{'SUBSCRIPTION' | translate}} #{{ sub.id }}</span>
          </div>
          <div class="status-badge" [ngClass]="getStatusClass(sub)">
            <mat-icon>{{ getStatusIcon(sub) }}</mat-icon>
            <span>{{ getStatusText(sub) }}</span>
            <div class="status-details" *ngIf="getStatusDetails(sub).message">
              <small>{{ getStatusDetails(sub).message }}</small>
            </div>
          </div>
        </div>
        <div class="header-right">
          <button mat-icon-button [matMenuTriggerFor]="menu" class="more-options">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="viewDetails(sub)">
              <mat-icon>visibility</mat-icon>
              <span>View Details</span>
            </button>
            <button mat-menu-item (click)="showRenewOptions(sub)" [disabled]="!canRenew(sub)">
              <mat-icon>autorenew</mat-icon>
              <span>Renew</span>
            </button>
            <button mat-menu-item (click)="downloadInvoice(sub)" [disabled]="!hasInvoice(sub)">
              <mat-icon>download</mat-icon>
              <span>Download Invoice</span>
            </button>
            
          </mat-menu>
        </div>
      </div>

      <!-- Card Body -->
      <div class="card-body">
        <!-- Basic Info -->
        <div class="info-section">
          <div class="info-row">
            <span class="info-label">{{'ORGANIZATION_ID' | translate}}:</span>
            <span class="info-value">{{ sub.organization_id }}</span>
          </div>
          <!-- <div class="info-row">
            <span class="info-label">Duration:</span>
            <span class="info-value">{{ sub.duration }} months</span>
          </div>  -->
          <div class="info-row">
            <span class="info-label">{{'TOTAL_AMOUNT' | translate}}:</span>
            <span class="info-value amount">₹{{ sub.total_amount }}</span>
          </div>
          <!-- <div class="info-row">
            <span class="info-label">Users:</span>
            <span class="info-value">{{ sub.users_count }}</span>
          </div> -->
        </div>

        <!-- Date Range -->
        <div class="date-section">
          <div class="date-range">
            <div class="date-item">
              <mat-icon>event_available</mat-icon>
              <div class="date-content">
                <span class="date-label">{{'START_DATE_' | translate}}</span>
                <span class="date-value">{{ sub.membership_start_date | date:'mediumDate' }}</span>
              </div>
            </div>
            <div class="date-separator">
              <mat-icon>arrow_forward</mat-icon>
            </div>
            <div class="date-item">
              <mat-icon>event_busy</mat-icon>
              <div class="date-content">
                <span class="date-label">{{'END_DATE_' | translate}}</span>
                <span class="date-value">{{ sub.membership_end_date | date:'mediumDate' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Membership Status Details -->
        <div class="status-details-section" *ngIf="getStatusDetails(sub)">
          <h4 class="section-title">
            <mat-icon>info</mat-icon>
            {{'MEMBERSHIP_STATUS' | translate}}
          </h4>
          <div class="status-info-grid">
            <div class="status-info-item">
              <span class="info-label">{{'STATUS' | translate}}:</span>
              <span class="info-value" [ngClass]="getStatusClass(sub)">{{ getStatusText(sub) }}</span>
            </div>
            <div class="status-info-item" *ngIf="getStatusDetails(sub).daysRemaining > 0">
              <span class="info-label">{{'DAYS_REMAINING' | translate}}:</span>
              <span class="info-value">{{ getStatusDetails(sub).daysRemaining }}</span>
            </div>
            <div class="status-info-item" *ngIf="getStatusDetails(sub).daysExpired > 0">
              <span class="info-label">Days Expired:</span>
              <span class="info-value">{{ getStatusDetails(sub).daysExpired }}</span>
            </div>
            <div class="status-info-item" *ngIf="getStatusDetails(sub).gracePeriodRemaining > 0">
              <span class="info-label">Grace Period:</span>
              <span class="info-value">{{ getStatusDetails(sub).gracePeriodRemaining }} days left</span>
            </div>
            <div class="status-info-item">
              <span class="info-label">{{'ACCESS' | translate}}:</span>
              <span class="info-value" [ngClass]="getStatusDetails(sub).canAccess ? 'access-granted' : 'access-denied'">
                {{ getStatusDetails(sub).canAccess ? 'Granted' : 'Denied' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Domain Usage -->
        <div class="domains-section">
          <h4 class="section-title">
            <mat-icon>domain</mat-icon>
           {{'DOMAIN_USAGE' | translate}}
          </h4>
          <div class="domains-grid">
            <div class="domain-item" *ngIf="domainHasEntitlement(sub.road)">
              <div class="domain-icon roads">
                <mat-icon>roads</mat-icon>
              </div>
              <div class="domain-info">
                <span class="domain-name">Road</span>
                <span class="domain-stats"> Users: {{ sub.road.users_count }}</span>
              </div>
            </div>

            <div class="domain-item" *ngIf="domainHasEntitlement(sub.construction)">
              <div class="domain-icon commercial">
                <mat-icon>business</mat-icon>
              </div>
              <div class="domain-info">
                <span class="domain-name">Construction</span>
                <span class="domain-stats"> Users: {{ sub.construction.users_count }}</span>
              </div>
            </div>

            <div class="domain-item" *ngIf="domainHasEntitlement(sub.education)">
              <div class="domain-icon education">
                <mat-icon>school</mat-icon>
              </div>
              <div class="domain-info">
                <span class="domain-name">Education</span>
                <span class="domain-stats">Area: {{ sub.education.area }} | Users: {{ sub.education.users_count }}</span>
              </div>
            </div>

            <div class="domain-item" *ngIf="domainHasEntitlement(sub.utilities)">
              <div class="domain-icon utilities">
                <mat-icon>power</mat-icon>
              </div>
              <div class="domain-info">
                <span class="domain-name">Utilities</span>
                <span class="domain-stats">Length: {{ sub.utilities.length }} | Users: {{ sub.utilities.users_count }}</span>
              </div>
            </div>

            <div class="domain-item" *ngIf="domainHasEntitlement(sub.consultancy)">
              <div class="domain-icon consultancy">
                <mat-icon>analytics</mat-icon>
              </div>
              <div class="domain-info">
                <span class="domain-name">Consultancy</span>
                <span class="domain-stats">{{ consultancyDomainStats(sub) }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && !error && subscriptions.length === 0">
    <div class="empty-content">
      <mat-icon class="empty-icon">subscriptions</mat-icon>
      <h2>No Active Subscriptions</h2>
      <p>You don't have any active subscription plans. Start by exploring our available packages.</p>
      <button mat-raised-button color="primary" (click)="explorePackages()">
        <mat-icon>explore</mat-icon>
        Explore Packages
      </button>
    </div>
  </div>

</div>

  <!-- <mat-button-toggle-group [value]="billingCycle" (change)="setBillingCycle($event?.value)" appearance="legacy"
    class="billing-toggle">
    <mat-button-toggle value="Annual">Annual</mat-button-toggle>
    <mat-button-toggle value="Monthly">Monthly</mat-button-toggle>
  </mat-button-toggle-group> -->


  <div *ngIf="false" class="plans">
    <mat-card 
      class="plan-card" 
      *ngFor="let package of packageList"
      [ngClass]="{ active: isSelected(package?.package_name) }"
      (click)="selectPlan(package?.package_name)"
    >
      <div class="tag">{{'ACTIVE' | translate}}</div>
      <h3>{{ package?.package_name }}</h3>
      <p class="price">₹{{ package?.amount }} <span>/ month (INR)</span></p>
      <p class="billed">₹{{ package?.amount }} billed yearly</p>
      <p class="desc">Ideal for small teams with fundamental needs</p>

      <ul>
        <li><mat-icon>check_circle</mat-icon> Access to core HR features</li>
        <li><mat-icon>check_circle</mat-icon> Employee record management</li>
        <li><mat-icon>check_circle</mat-icon> Basic reporting tools</li>
        <li><mat-icon>check_circle</mat-icon> Manage up to {{ package?.user_count }} team members</li>
        <li><mat-icon>check_circle</mat-icon> Manage up to {{ package?.project_count }} projects</li>
        <li><mat-icon color="warn">cancel</mat-icon> Track employee attendance</li>
        <li><mat-icon color="warn">cancel</mat-icon> Assign and monitor tasks</li>
        <li><mat-icon color="warn">cancel</mat-icon> Email support</li>
      </ul>
      
      <button mat-stroked-button color="warn" (click)="openPackageDialog(package)">Subscribe</button>
    </mat-card>
  </div>
